/* -----------------------------------------------------------------------------
 * Toggle switch
 * -------------------------------------------------------------------------- */
import { getLogger } from './utils/logger-context';
import { resolveComponentScope } from './utils/resolveComponentScope';

const COMPONENT_NAME = 'ToggleSwitch';

export const init = (unresolvedScope) => {
    const logger = getLogger();
    const scope = resolveComponentScope(unresolvedScope);
    const defaultLoggerArgs = {
        componentName: COMPONENT_NAME,
        scope,
    };
    logger.debug(`Initialising ${COMPONENT_NAME} component.`, {
        scope: document,
    });

    $('.tako-switch').each(function () {
        try {
            const input = $(this).find('.tako-form-control--switch');
            const toggleSwitch = $(this).find('.tako-switch__toggle');
            const toggleSwitchHTML = `<div class="tako-switch__toggle"></div>`;

            // Add the toggle switch after the hidden checkbox input
            if (!toggleSwitch.length) {
                input.after(toggleSwitchHTML);
            }
        } catch (error) {
            logger.error(error, {
                ...defaultLoggerArgs,
                element: this,
            });
        }
    });
};
